import clsx from 'clsx';
import React, { forwardRef } from 'react';

import { FaRegularChevronLeftIcon } from '@/common/components/icons';
import { Link } from '@/common/components/link';

export const BackLink = forwardRef<
  React.ComponentRef<typeof Link>,
  React.ComponentPropsWithoutRef<typeof Link>
>(({ className, children, ...props }, ref) => {
  return (
    <Link
      className={clsx(className, 'inline-flex items-center gap-2 text-sm/6 text-zinc-500 dark:text-zinc-400')}
      {...props}
      ref={ref}
    >
      <>
        <FaRegularChevronLeftIcon className="size-3 fill-zinc-400 dark:fill-zinc-500" />
        {children}
      </>
    </Link>
  );
});
